import * as Sentry from '@sentry/react';
import type { Store } from 'redux';

import type { RootState } from './state/root-reducer';

/**
 * Keeps Sentry user context in sync with Redux auth using FinPay userProfile.userId.
 */
export function subscribeSentryUserToStore(store: Store<RootState>): void {
  const sync = () => {
    const { userIsAuthenticated, userProfile } = store.getState().userContext;

    if (userIsAuthenticated && userProfile.userId > 0) {
      Sentry.setUser({ id: String(userProfile.userId) });
    } else {
      Sentry.setUser(null);
    }
  };

  store.subscribe(sync);
  sync();
}
